import React from 'react';
import { Row, Col, Card, CardBody, CardText, Button } from 'reactstrap';
import './historico-laudo.styles.css';

import IntlMessage from "../../../../../../helpers/intlMessage";

const HistoricoLaudoPage = (props) => {
  return (
    <Col
      style={{
        height: props.alturaEditor(),
        overflowY: 'auto',
        overflowX: 'hidden',
      }}
      className='mv-historico-container espacamento-container-lateral'
    >
      {props.laudoHistoricoLista.length === 0 && (
        <p className='mv-semItem'><IntlMessage id = "dashboards.examDetail.noHistoryRecorded"/></p>
      )}
      {props.textoLaudoHistorico === undefined &&
        props.laudoHistoricoLista.map((laudo) => {
          return (
            <Row key={laudo.laudoHistoricoId}>
              <Col>
                <Card onClick={() => props.obterDetalhesLaudoHistorico(laudo)}>
                  <CardBody>
                    <CardText>
                      <IntlMessage id = "dashboards.examDetail.dateChange"/>
                      {` ${laudo.dataAlteracao}`}
                      </CardText>
                       <CardText>
                      <IntlMessage id = "general.materialArchiving.type"/>:
                      {` ${laudo.tipoOperacao}`}
                      </CardText>
                    <CardText>
                      <IntlMessage id = "dashboards.examDetail.user"/>
                      {` ${laudo.usuario}`}
                      </CardText>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          );
        })}
      {props.textoLaudoHistorico !== undefined && (
        <Row className='historico-laudo-texto'>
          <Col>
            <Button
              style={{ float: 'right' }}
              color='link'
              onClick={props.fecharDetalhesTextoLaudoHistorico}
            >
              <i className='fas fa-times fa-1x'></i>
            </Button>
            <div className='detalhes'>
              <span>
                <IntlMessage id = "dashboards.examDetail.dateChange"/>
                {`${props.textoLaudoHistorico.dataAlteracao}`}
              </span>
              <br />
              <span>
                <IntlMessage id = "dashboards.examDetail.user"/>
                {`${props.textoLaudoHistorico.usuario}`}
              </span>
            </div>
            <textarea
              ref={props.textAreaRef}
              readOnly
              value={props.textoLaudoHistorico.texto}
              style={{ height: `${props.textAreaAltura}` }}
            />
          </Col>
        </Row>
      )}
    </Col>
  );
};

export default HistoricoLaudoPage;



// WEBPACK FOOTER //
// ./src/pages/laudo/etapas/macroscopia/tabs/historicolaudo/historico-laudo.page.js